<div class="class404_mainwrapper">
    <div class="class404_subwrapper">
        <h4><i class="fa fa-frown-o" aria-hidden="true"></i></h4>
        <h1>404</h1>
        <p>Page not found</p>
    </div>
</div>
